import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {UserModel} from './user.model';
import {Observable} from 'rxjs/Observable';
import {UserService} from './user.service';

@Injectable()
export class PagesResolver implements Resolve<UserModel> {

  constructor(private userService: UserService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserModel> | Promise<UserModel> | UserModel {
    return this.userService.getMe().map(user => {
      if (user) {
        return user;
      }

      this.router.navigate(['/login']);
      return null;
    });
  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/pages.resolver.ts